// components/Marquee/Marquee.tsx
import React from 'react';
import styles from './Marquee.module.scss';

interface MarqueeProps {
  children: React.ReactNode;
  duration?: number; // seconds per loop (default: 20)
  direction?: 'left' | 'right';
  pauseOnHover?: boolean;
  className?: string;
}

// Fully CSS-driven marquee: the track holds two identical copies of the
// content and animates translateX(0 -> -50%), so the loop is seamless at any
// content width with no JS measurement, state, or effects.
// Children are rendered directly (no per-item wrapper); spacing between items
// comes from the children's own margins.
const Marquee: React.FC<MarqueeProps> = ({
  children,
  duration = 20,
  direction = 'left',
  pauseOnHover = true,
  className = ''
}) => {
  const renderContent = (isClone = false) => (
    <div
      className={`${styles.contentGroup} ${isClone ? styles.clone : styles.originalContent}`}
      aria-hidden={isClone}
    >
      {children}
    </div>
  );

  return (
    <div
      className={`${styles.marquee} ${pauseOnHover ? styles.pausable : ''} ${className}`}
      role="region"
      aria-label="Scrolling brand images"
    >
      <div
        className={`${styles.content} ${
          direction === 'right' ? styles.reverse : ''
        }`}
        style={{
          '--animation-duration': `${duration}s`,
        } as React.CSSProperties}
      >
        {/* Original content */}
        {renderContent(false)}

        {/* Clone for seamless infinite scroll */}
        {renderContent(true)}
      </div>
    </div>
  );
};

export default Marquee;
